import { createMigrate } from "redux-persist";
import LS from "../../../utils/LocalStorage";
import { LocalStorageEnum } from "../../../utils/enums";

/**
 * v1 drops the persisted `entityImageLookup` once, and the MENU_DATA copy it
 * would otherwise be rebuilt from.
 *
 * Both were built before `/category/details` shipped `hiddenItemCategories`, so
 * they have no entry for items hidden from the menu and an offer rewarding one
 * reads "Item(s) unavailable". useEntityImageLookup only rebuilds an EMPTY
 * lookup (preferring MENU_DATA), and only /home rebuilds a full one, so a
 * returning guest who opens /rewards or /cart directly would keep the stale
 * one. With both gone, the next page rebuilds it from the current menu.
 *
 * `createMigrate` runs this only while the stored version is below 1, not on
 * every rehydration.
 */
export const migrateConfig = createMigrate(
  {
    1: (state) => {
      LS._delete(LocalStorageEnum.MENU_DATA);

      return state && ({ ...state, entityImageLookup: {} } as typeof state);
    },
  },
  { debug: false }
);
